import { SelectFilter, SelectOption } from "../types/filters";
import { carModelsData } from "./carModels";

const countrySelectOptions: SelectOption[] = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  { value: "FR", label: "France" },
  { value: "DE", label: "Germany" },
];

// Values MUST match the stored `body_type` field exactly (case-sensitive).
export const carTypeSelectOptions: SelectOption[] = [
  { value: "SUV", label: "SUV" },
  { value: "Hatchback", label: "Hatchback" },
  { value: "Sedan", label: "Sedan" },
  { value: "Minivan", label: "Minivan" },
  { value: "Wagon", label: "Wagon" },
  { value: "Van", label: "Van" },
  { value: "Coupe", label: "Coupe" },
  { value: "Truck", label: "Truck" },
  { value: "Convertible", label: "Convertible" },
];

// Price range bands (JPY). Encoded as "min-max" ("min-" = open-ended top).
export const priceRangeSelectOptions: SelectOption[] = [
  { value: "0-1000000", label: "Under ¥1M" },
  { value: "1000000-2000000", label: "¥1M – ¥2M" },
  { value: "2000000-3000000", label: "¥2M – ¥3M" },
  { value: "3000000-5000000", label: "¥3M – ¥5M" },
  { value: "5000000-10000000", label: "¥5M – ¥10M" },
  { value: "10000000-", label: "Over ¥10M" },
];

const convertCarModelsData = (data: {
  [key: string]: string[];
}): SelectOption[] => {
  return Object.entries(data).flatMap(([brand, models]) =>
    models.map((model) => ({
      value: `${model}`,
      label: model,
    }))
  );
};

const carModelSelectOptions: SelectOption[] =
  convertCarModelsData(carModelsData);

const carMakeSelectOptions: SelectOption[] = [
  { value: "toyota", label: "Toyota" },
  { value: "mercedes", label: "Mercedes" },
  { value: "bmw", label: "BMW" },
  { value: "suzuki", label: "Suzuki" },
  { value: "nissan", label: "Nissan" },
  { value: "honda", label: "Honda" },
  { value: "lexus", label: "Lexus" },
  { value: "mitsubishi", label: "Mitsubishi" },
  { value: "mazda", label: "Mazda" },
  { value: "subaru", label: "Subaru" },
  { value: "daihatsu", label: "Daihatsu" },
  { value: "hino", label: "Hino" },
  { value: "isuzu", label: "Isuzu" },
];

const yearSelectOptions: SelectOption[] = Array.from(
  { length: 2026 - 2016 + 1 },
  (_, i) => 2026 - i
).map((year) => ({
  value: year.toString(),
  label: year.toString(),
}));

export const currencies = [
  { locales: "en-US", currency: "USD" },
  {
    locales: "ja",
    currency: "JPY",
  },
];

export const filtersData: Record<string, SelectFilter> = {
  type: {
    label: "Type",
    options: carTypeSelectOptions,
  },
  make: {
    label: "Make",
    options: carMakeSelectOptions,
  },
  year: {
    label: "Year",
    options: yearSelectOptions,
  },
  model: {
    label: "Model",
    options: carModelSelectOptions,
  },
  price: {
    label: "Price",
    options: priceRangeSelectOptions,
  },
};
